import {
  ACTION_DELETE_SITE_GOOGLE_TOOL__REQUEST,
  ACTION_DELETE_SITE_GOOGLE_TOOL__SUCCESS,
  ACTION_DELETE_SITE_GOOGLE_TOOL__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_GOOGLE_TOOL__REQUEST:
    case ACTION_DELETE_SITE_GOOGLE_TOOL__SUCCESS:
      return null;

    case ACTION_DELETE_SITE_GOOGLE_TOOL__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
